import React from 'react'
import { connect } from 'react-redux'
import App from './App'
import SplashModal from './SplashModal'
import cookie from 'react-cookie'
import { getLayouts, setGroup, getLanguages, toggleKeyboard, setFunctionBarType } from '../actions/layoutActions'
import { getPosList, setSplashModal, setPos, getLicenses, getVersion } from '../actions/generalActions'
import { getTranslation } from '../actions/dataActions'
import { getUsers } from '../actions/loginActions'
import { getObjectGroupList } from '../objectmanagement/actions/objectManagementActions'
import * as general from '../constants/General'
import * as resource from '../constants/Resources'
import PropTypes from 'prop-types'

class AppLoader extends React.Component {
  constructor(props) {
    super(props);
    this.renderApp = this.renderApp.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.setData = this.setData.bind(this);
    this.retryHandel = this.retryHandel.bind(this);
    this.state = {
      dataReceived: false
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  setData() {
    // Set the function bar
    this.props.setFunctionBarType(general.FUNCTIONBAR_NONE);

    // Disable keyboard by default
    this.props.toggleKeyboard(false);

    // If only one pos, set that as the default selected
    if (this.props.posList.length === 1) {
      this.props.setPos(this.props.posList[0].PosId, this.props.posList[0].Description, this.props.posList[0].PosType, this.props.posList[0].PrintReceiptInfo, this.props.posList[0].DisplayMode, this.props.posList[0].ResetTime, this.props.posList[0].UseConfigurations, this.props.posList[0].AllowEmptyPrice, this.props.posList[0].OpeningTime, this.props.posList[0].ClosingTime, this.props.posList[0].UsePager, this.props.posList[0].HasBlackbox);
    }

    // Check if POS cookie is set, if so, set last used POS as selected
    let lastPos = cookie.load(general.COOKIE_POS_LASTPOSID, { path: '/' });
    if (lastPos !== undefined) {
      lastPos = parseInt(lastPos, 10);

      let posDesc = this.props.getTranslation(resource.CHOOSE_ENVIRONMENT);
      let posType = 0;
      let posPrintReceiptInfo = false;
      let displayMode = null;
      let posResetTime = 0;
      let useConfigurations = true;
      let usePager = false;
      let allowEmptyPrice = true;
      let openingTime = null;
      let closingTime = null;
      let hasBlackbox = true;
      this.props.posList.map(pos => {
        if (pos.PosId === lastPos) {
          posDesc = pos.Description;
          posType = pos.PosType;
          posPrintReceiptInfo = pos.PrintReceiptInfo;
          displayMode = pos.DisplayMode;
          posResetTime = pos.ResetTime;
          useConfigurations = pos.UseConfigurations;
          allowEmptyPrice = pos.AllowEmptyPrice;
          openingTime = pos.OpeningTime;
          closingTime = pos.ClosingTime;
          usePager = pos.UsePager;
          hasBlackbox = pos.HasBlackbox;
        }
        return '';
      });
      this.props.setPos(lastPos, posDesc, posType, posPrintReceiptInfo, displayMode, posResetTime, useConfigurations, allowEmptyPrice, openingTime, closingTime, usePager, hasBlackbox);
    }
  }

  retryHandel() {
    this.fetchData();
  }

  fetchData() {
    this.props.setSplashModal(true, 'Fetch translations...', false);
    this.props.getLanguages().then(() => {
      this.props.setSplashModal(true, this.props.getTranslation(resource.FETCH_CASHREGISTER_ENVIRONMENT), false);
      this.props.getPosList().then(() => {
        this.props.setSplashModal(true, this.props.getTranslation(resource.FETCH_USERS), false);
        this.props.getUsers().then(() => {
          this.props.setSplashModal(true, this.props.getTranslation(resource.FETCH_LICENSES), false);
          this.props.getLicenses().then(() => {
            this.props.getVersion().then(() => {
              this.props.setSplashModal(true, this.props.getTranslation(resource.PREPARE_CASHREGISTER), false);
              this.setData();
              this.setState({ dataReceived: true });
              this.props.setSplashModal(false, 'default', false);
            })
          })
        })
      })
    }).catch(() => { this.props.setSplashModal(true, this.props.getTranslation(resource.ERROR_FETCHING_DATA), true) });
  }

  renderApp() {
    const { children } = this.props;
    return (this.state.dataReceived)
      ? <App children={children} />
      : <div className="DataNotReceived"></div>
  }

  render() {
    return (
      <div id="appwrapper">
        {this.renderApp()}
        <SplashModal retryHandel={this.retryHandel} />
      </div>
    )
  }
}

AppLoader.propTypes = {
  getLanguages: PropTypes.func.isRequired,
  getPosList: PropTypes.func.isRequired,
  getObjectGroupList: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  getLayouts: PropTypes.func.isRequired,
  setSplashModal: PropTypes.func.isRequired,
  toggleKeyboard: PropTypes.func.isRequired,
  setFunctionBarType: PropTypes.func.isRequired,
  setPos: PropTypes.func.isRequired,
  setGroup: PropTypes.func.isRequired,
  children: PropTypes.object.isRequired,
  groups: PropTypes.object.isRequired,
  posList: PropTypes.array.isRequired,
  getLicenses: PropTypes.func
}

function mapStateToProps(state) {
  return {
    groups: state.layoutState.groups,
    posList: state.generalState.posList
  }
}

export default connect(mapStateToProps,
  {
    getLanguages,
    getPosList,
    getUsers,
    getObjectGroupList,
    getLayouts,
    setGroup,
    setSplashModal,
    setPos,
    toggleKeyboard,
    setFunctionBarType,
    getLicenses,
    getVersion,
    getTranslation
  })(AppLoader)



// WEBPACK FOOTER //
// src/components/AppLoader.jsx